<template>
  <div class="copay-epa-source-item">
    <b-form>
      <b-card no-body class="mx-12">
        <b-card-body class="p-12">
          <b-row>
            <b-col>
              <b-form-group id="fieldsetSourceName"
                            :label-cols="4"
                            breakpoint="md"
                            label="Source Name:"
                            label-for="inputSourceName">
                <div class="form-value">{{source.source_name | capitalizeRemoveHyphen }}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="source.filter_settings && source.source_name ==='horizon'">
            <b-col>
              <VCopayEPAFilterList :filters="source.filter_settings"
                                   @edit="editFilter"
                                   @remove="removeFilter"
                                   @approve="approveFilter"
                                   @deny="denyFilter"
                                   @publish="publishFilter"
                                   @request-approval="requestApprovalFilter"
                                   @view-active="viewActiveSetting"
                                   @cancel-update="cancelUpdateFilter"
                                   :busy="isBusy"
                                   :isAdmin="isInRole('RxChangeDataAdmin')"
                                   :isApprover="isInRole('RxChangeDataApprover')"
                                   :showRejectionCodes="false"
                                   :showFilterRules="false"
                                   :showOCCDrugNames="true"></VCopayEPAFilterList>
            </b-col>
          </b-row>
          <b-row v-if="source_name== 'api'">
            <b-col sm="4">
              <b-form-group id="fieldsetCmmStartDate"
                            breakpoint="md"
                            label="CMM Start Date:"
                            label-for="inputCmmStartDate">
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group id="inputCmmStartDate">
                <date-picker name="inputCmmStartDate"
                             v-model="cmmStartDate"
                             debounce="500"
                             v-validate="'required'"
                             data-vv-as="Start Date"
                             class="form-control"
                             :class="{'is-invalid' : invalidCmmStartDate}"
                             type="date"
                             lang="en"
                             format="YYYY-MM-DD"
                             confirm
                             placeholder="YYYY-MM-DD"></date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="1">
              <b-button @click.prevent="saveCmmStartDate" v-show='isToggled' variant="outline-secondary" title="Save Start Date">Save</b-button>
            </b-col>
          </b-row>
          <b-row v-if="source_name== 'api'">
            <b-col>
              <b-form-group id="fieldsetCmm"
                            :label-cols="4"
                            breakpoint="md"
                            label="Can Send Expired Claims to CMM:"
                            label-for="inputCmm">
                <toggle-button @change="showConfirmSaveCmmSettings" :value="isToggled" :sync="true" :labels="true" :disabled='disableControls' />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="source.source_type=='file'">
            <b-col>
              <b-form-group id="fieldsetPharmacies"
                            :label-cols="4"
                            breakpoint="md"
                            label="Pharmacies:"
                            label-for="listPharmacies"></b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="source.source_type=='file'">
            <b-col>
              <VCopayEPAPharmacySettings :pharmacy_setting="source.file_source_settings"
                                         @edit="editPharmacy"
                                         @remove="removePharmacy"
                                         @approve="approvePharmacy"
                                         @publish="publishPharmacy"
                                         @request-approval="requestApprovalPharmacy"
                                         @view-active="viewActiveSetting"
                                         @cancel-update="cancelUpdatePharmacy"
                                         :busy="isBusy"
                                         :isAdmin="isInRole('RxChangeDataAdmin')"
                                         :isApprover="isInRole('RxChangeDataApprover')"></VCopayEPAPharmacySettings>
            </b-col>
            <b-col class="filter-add" cols="1">
              <a v-if="isInRole('RxChangeDataAdmin')" @click="addPharmacy">
                <i class="fa fa-plus-circle"></i>
              </a>
            </b-col>
          </b-row>
          <b-row v-if="source.filter_settings && source.source_type !=='file'">
            <b-col>
              <b-form-group id="fieldsetFilters"
                            :label-cols="3"
                            breakpoint="md"
                            label="Filters:"
                            label-for="listFilters"></b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="fieldFilterName" nowrap :label-cols="4" label-size="sm" align-v="right"
                            label="Filter Name:"
                            label-for="filterByFriendlyName">
                <b-form-input id="filterByFriendlyName" v-model="filter_friendly_name" v-on:keyup.enter="filterByFriendlyNameAndNdc" placeholder="Search Friendly Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="fieldFilterNDC" nowrap :label-cols="3" label-size="sm" align-v="right"
                            breakpoint="md"
                            label="NDC:"
                            label-for="filterByNDC">
                <b-form-input id="filterByNDC" v-model="filter_ndc_num" v-on:keyup.enter="filterByFriendlyNameAndNdc" placeholder="Search NDC"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-row align-v="center">
                <div>
                  <b-button @click.prevent="filterByFriendlyNameAndNdc" title="Apply Filter">Search</b-button>
                  <b-button variant="link" @click.prevent="clearSearchFilter" title="Clear Filter">Clear</b-button>
                </div>
              </b-row>
            </b-col>

          </b-row>
          <b-row v-if="source.filter_settings && source.source_type !=='file'">
            <b-col>
              <VCopayEPAFilterList :filters="source.filter_settings"
                                   @edit="editFilter"
                                   @remove="removeFilter"
                                   @approve="approveFilter"
                                   @deny="denyFilter"
                                   @publish="publishFilter"
                                   @request-approval="requestApprovalFilter"
                                   @view-active="viewActiveSetting"
                                   @cancel-update="cancelUpdateFilter"
                                   :busy="isBusy"
                                   :isAdmin="isInRole('RxChangeDataAdmin')"
                                   :isApprover="isInRole('RxChangeDataApprover')"
                                   :showRejectionCodes="true"
                                   :showFilterRules="true"
                                   :showOCCDrugNames="false"></VCopayEPAFilterList>
            </b-col>
            <b-col class="filter-add" cols="1">
              <a v-if="isInRole('RxChangeDataAdmin')" @click="addFilter">
                <i class="fa fa-plus-circle"></i>
              </a>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
    <b-modal ref="filterItemModalRef"
             size="lg"
             @ok="saveFilter"
             @show="onFilterShow"
             title="Filter"
             :busy="isBusy">
      <div slot="modal-ok">
        OK
        <i v-if="isBusy" class="fa fa-spinner fa-pulse button-spinner"></i>
      </div>
      <div v-if="source.source_name !== 'horizon'">
        <VCopayEPAFilterItem ref="filterItemRef" :filter="selectedFilter" :isReadonly="isReadonly"></VCopayEPAFilterItem>
      </div>
      <div v-if="source.source_name === 'horizon'">
        <VCopayEPAFilterItemHorizon ref="filterItemRef" :filter="selectedFilter" :isReadonly="isReadonly"></VCopayEPAFilterItemHorizon>
      </div>
    </b-modal>
    <b-modal ref="pharmacyItemModalRef"
             size="lg"
             @ok="savePharmacy"
             title="Pharmacy"
             :busy="isBusy">
      <div slot="modal-ok">
        OK
        <i v-if="isBusy" class="fa fa-spinner fa-pulse button-spinner"></i>
      </div>
      <VCopayEPAPharmacyItem ref="pharmacyItemRef"
                             :pharmacy="selectedPharmacy"
                             :isReadonly="isReadonly"></VCopayEPAPharmacyItem>
    </b-modal>
    <b-modal ref="cmm-modal" v-model="cmmModalShow" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
      <div class="d-block">
        <b-alert variant="danger" v-model="cmmModalShow">
          <p>
            On: will send expired claims to CMM;
            Off: will not send expired claims to CMM,
            once set to on, all previously expired claims will be sent to CMM since switch was set to Off.
            Do you wish to continue?
          </p>
        </b-alert>
      </div>
      <b-button class="mt-3" block @click="oncmmModalShowYesClick()">Yes</b-button>
      <b-button class="mt-3" block @click="oncmmModalShowNoClick()">No</b-button>
    </b-modal>
  </div>
</template>

<script>
// @ts-check
import DatePicker from "vue2-datepicker";
import { mapGetters, mapState } from "vuex";
import VCopayEPAFilterList from "@/components/VCopayEPAFilterList";
import VCopayEPAFilterItem from "@/components/VCopayEPAFilterItem";
import VCopayEPAFilterItemHorizon from "@/components/VCopayEPAFilterItemHorizon";
import VCopayEPAPharmacySettings from "@/components/VCopayEPAPharmacySettings";
import VCopayEPARetrySetting from "@/components/VCopayEPARetrySetting";
import VCopayEPAPharmacyItem from "@/components/VCopayEPAPharmacyItem";

import {
  SOURCE_GET,
  SOURCE_FILTER_ADD,
  SOURCE_FILTER_SAVE,
  SOURCE_FILTER_REMOVE,
  SOURCE_FILTER_REQUESTAPPROVAL,
  SOURCE_FILTER_APPROVE,
  SOURCE_FILTER_DENY,
  SOURCE_FILTER_PUBLISH,
  SOURCE_FILTER_CANCEL,
  SOURCE_GET_SETTING,
  SOURCE_PHARMACY_ADD,
  SOURCE_PHARMACY_SAVE,
  SOURCE_PHARMACY_REMOVE,
  SOURCE_PHARMACY_REQUESTAPPROVAL,
  SOURCE_PHARMACY_APPROVE,
  SOURCE_PHARMACY_PUBLISH,
  SOURCE_PHARMACY_CANCEL
} from "@/store/copay-epa-source/actions.type";
export default {
  name: "CopayEPASourceItem",
  components: {
    DatePicker,
    VCopayEPAFilterList,
    VCopayEPAPharmacySettings,
    VCopayEPARetrySetting,
    VCopayEPAPharmacyItem,
    VCopayEPAFilterItem,
    VCopayEPAFilterItemHorizon
  },
  data() {
    return {
      selectedFilter: {},
      selectedPharmacy: {},
      isReadonly: false,
      cmmModalShow: false,
      invalidCmmStartDate: false,
      cmmStartDate: '',
      disableControls: false,
      filter_friendly_name: "",
      filter_ndc_num: "",
      default_parser_mapping: { patient_first_name: { }, patient_last_name: { }, date_of_birth: { }, pt_address_line1: { }, pt_address_line2: { source_index: -1 }, pt_city: { }, pt_state: { }, pt_zip_code: { }, gender_code: { }, pt_phone_number: { source_index: -1 }, prescriber_npi: { }, prescriber_dea: { source_index: -1 }, prescriber_fn: { }, prescriber_ln: { }, prescriber_add1: { }, prescriber_add2: { source_index: -1 }, prescriber_city: { }, prescriber_state: { }, prescriber_zip: { }, prescriber_phone: { }, prescriber_fax: { }, pharmacy_name: { }, pharmacy_npi: { source_index: -1 }, pharmacy_ncpdp_number: { source_index: -1 }, pharmacy_add1: { source_index: -1 }, pharmacy_add2: { source_index: -1 }, pharmacy_city: { source_index: -1 }, pharmacy_state: { source_index: -1 }, pharmacy_zip: { source_index: -1 }, pharmacy_phone: { }, pharmacy_fax: { source_index: -1 }, claim_date: { }, primary_payer_pbm_name: { source_index: -1 }, primary_payer_bin: { source_index: -1 }, primary_payer_pcn: { source_index: -1 }, primary_payer_plan_id: { source_index: -1 }, primary_payer_plan_name: { source_index: -1 }, primary_payer_group_id: { source_index: -1 }, primary_payer_group_name: { source_index: -1 }, copay_payer_bin: { source_index: -1 }, copay_payer_pcn: { source_index: -1 }, copay_payer_group_id: { source_index: -1 }, copay_payer_member_id: { source_index: -1 }, cob_primary_reject_code1: { source_index: -1 }, cob_primary_reject_code2: { source_index: -1 }, cob_primary_reject_code3: { source_index: -1 }, patient_out_of_pocket: { source_index: -1 }, other_coverage_code: { source_index: -1 }, rx_number: { }, date_filled: { source_index: -1 }, drug_ndc_number: { }, drug_name: { }, quantity_dispensed: { }, days_supply: { source_index: -1 }, number_of_refills_authorized: { }, daw_code: { }, date_written: { }, new_or_refill: { source_index: -1 }, fill_number: { source_index: -1 } }
    };
  },
  props: {
    source_name: {
      required: true,
      type: String
    }
  },
  watch: {
    source_name: function(newVal, oldVal) {
      // watch it
      if (newVal !== oldVal) {
        this.filter_friendly_name = "";
        this.filter_ndc_num = "";
      }
      this.filterByFriendlyNameAndNdc();
    },
    activeSetting: function(newVal, oldVal) {
      if (newVal.setting_type === "filter") {
        this.selectedFilter = newVal;
        this.$refs.filterItemModalRef.$validator.reset();
        this.$refs.filterItemModalRef.show();
      } else if (newVal.setting_type === "file") {
        this.selectedPharmacy = newVal;
        this.$refs.pharmacyItemModalRef.$validator.reset();
        this.$refs.pharmacyItemModalRef.show();
      }
    }
  },
  computed: {
    ...mapGetters({
      source: "currentSource",
      groups: "groups"
    }),
    ...mapState({
      isBusy: state => state.copayepasource.isBusy,
      activeSetting: state => state.copayepasource.currentSetting
    }),
    isToggled: function() {
      return this.source.can_send_expired_claims_to_cmm;
    },
    sourceSettings: function () {
        var settings = {
            source_name: this.source.source_name,
            setting_key_id: 'source-settings',
            setting_type: 'source',
            source_type: 'database',
            can_send_expired_claims_to_cmm: !this.isToggled,
            last_update_date_time: this.source.last_update_date_time,
            cmm_start_date: this.dateToStr(this.cmmStartDate)
        };
      return settings;
     }
  },
  methods: {
    isInRole(role) {
      return this.groups.indexOf(role) > -1;
    },
    filterByFriendlyNameAndNdc() {
      var filterCriteria = {
        source: this.source_name,
        filter: {
          filter_friendly_name: this.filter_friendly_name,
          filter_ndc_num: this.filter_ndc_num
        }
      };
      this.$store.dispatch(SOURCE_GET, filterCriteria)
        .then(result => {
          if (result && result.source_name === 'api') {
            this.cmmStartDate = this.strToDate(result.cmm_start_date);
          }
        });
    },
    clearSearchFilter() {
      this.filter_friendly_name = "";
      this.filter_ndc_num = "";
    },
    addFilter() {
      this.selectedFilter = {
        id: null,
        is_pending_inactivation: false,
        filter_ndc_numbers: [],
        filter_rejection_codes: [],
        filter_rules: null,
        setting_type: "filter",
        source_name: this.source_name,
        filter_pull_claim_date: "",
        occ_drug_names: [],
        claim_wraparound_enabled: false
      };
      if (this.source_name === "care-central") {
        this.selectedFilter.filter_any_rejection_codes = true;
      }
      this.$refs.filterItemModalRef.$validator.reset();
      this.$refs.filterItemModalRef.show();
    },
    editFilter(filter) {
      this.isReadonly = (!this.isInRole("RxChangeDataAdmin") || filter.status === 'pending_approval');
      this.selectedFilter = JSON.parse(JSON.stringify(filter));
      this.$refs.filterItemModalRef.$validator.reset();
      this.$refs.filterItemModalRef.show();
    },
    async saveFilter(evt) {
      if (this.isReadonly) {
        return;
      }

        evt.preventDefault();
        await this.$refs.filterItemRef.$validator
          .validateAll()
          .then(isValid => {
            if (!isValid) {
              return;
            }
            if (this.selectedFilter.setting_key_id) {
              this.$store
                .dispatch(SOURCE_FILTER_SAVE, this.selectedFilter)
                .then(result => {
                  if (result) this.$refs.filterItemModalRef.hide();
                });
            } else {
              this.$store
                .dispatch(SOURCE_FILTER_ADD, this.selectedFilter)
                .then(result => {
                  if (result) this.$refs.filterItemModalRef.hide();
                });
            }
          });
      },
      onFilterShow(evt) { },
      removeFilter(filter) {
        this.$store.dispatch(SOURCE_FILTER_REMOVE, filter);
      },
      requestApprovalFilter(filter) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_FILTER_REQUESTAPPROVAL, filter);
        }
      },
      approveFilter(filter) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_FILTER_APPROVE, filter);
        }
      },
      denyFilter(filter) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_FILTER_DENY, filter);
        }
      },
      publishFilter(filter) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_FILTER_PUBLISH, filter);
        }
      },
      cancelUpdateFilter(filter) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_FILTER_CANCEL, filter);
        }
      },
      viewActiveSetting(setting) {
        this.isReadonly = true;
        var activeSetting = JSON.parse(JSON.stringify(setting));
        activeSetting.request_active = true;
        this.$store.dispatch(SOURCE_GET_SETTING, activeSetting);
      },
      addPharmacy() {
        this.isReadonly = false;
        this.selectedPharmacy = {
          name: null,
          is_pending_inactivation: false,
          has_header: "",
          parser: "",
          setting_type: "file",
          source_name: this.source_name,
          parser_mapping: this.default_parser_mapping
        };
        this.$refs.pharmacyItemModalRef.$validator.reset();
        this.$refs.pharmacyItemModalRef.show();
      },
      editPharmacy(pharmacy) {
        this.isReadonly = (!this.isInRole("RxChangeDataAdmin") || pharmacy.status === 'pending_approval');
        this.selectedPharmacy = { ...pharmacy };
        if (this.selectedPharmacy.parser_mapping === undefined) {
          this.selectedPharmacy.parser_mapping = this.default_parser_mapping;
        }
        this.$refs.pharmacyItemModalRef.$validator.reset();
        this.$refs.pharmacyItemModalRef.show();
      },
      async savePharmacy(evt) {
        if (this.isReadonly) {
          return;
        }

        evt.preventDefault();
        await this.$refs.pharmacyItemRef.$validator
          .validateAll()
          .then(isValid => {
            if (!isValid) {
              return;
            }

            this.$refs.pharmacyItemRef.$refs.pharmacyRetrySettingRef.$validator
              .validateAll()
              .then(isValid => {
                if (!isValid) {
                  return;
                }

                this.$refs.pharmacyItemRef.$refs.pharmacyItemFileParserRef.$validator
                  .validateAll()
                  .then(isValid => {
                    if (!isValid && this.selectedPharmacy.parser === "CustomParser") {
                      return;
                    }

                    if (this.selectedPharmacy.setting_key_id) {
                      this.$store
                        .dispatch(SOURCE_PHARMACY_SAVE, this.selectedPharmacy)
                        .then(result => {
                          if (result) this.$refs.pharmacyItemModalRef.hide();
                        });
                    } else {
                      this.$store
                        .dispatch(SOURCE_PHARMACY_ADD, this.selectedPharmacy)
                        .then(result => {
                          if (result) this.$refs.pharmacyItemModalRef.hide();
                        });
                    }
                });
            });
        });
      },
      removePharmacy(pharmacy) {
        this.$store.dispatch(SOURCE_PHARMACY_REMOVE, pharmacy);
      },
      requestApprovalPharmacy(pharmacy) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_PHARMACY_REQUESTAPPROVAL, pharmacy);
        }
      },
      approvePharmacy(pharmacy) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_PHARMACY_APPROVE, pharmacy);
        }
      },
      publishPharmacy(pharmacy) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_PHARMACY_PUBLISH, pharmacy);
        }
      },
      cancelUpdatePharmacy(pharmacy) {
        if (!this.isBusy) {
          this.$store.dispatch(SOURCE_PHARMACY_CANCEL, pharmacy);
        }
      },
      showConfirmSaveCmmSettings() {
        this.cmmModalShow = this.validCmmStartDate();
      },
      oncmmModalShowNoClick() {
        this.$refs["cmm-modal"].hide();
      },
      oncmmModalShowYesClick() {
        this.$refs["cmm-modal"].hide();
        var settings = this.sourceSettings;
        if (!settings.can_send_expired_claims_to_cmm) {
          settings.cmm_start_date = '';
          this.cmmStartDate = null;
        }
        this.saveSourceFilter(settings);
      },
      saveSourceFilter(settings) {
        // console.log(settings);
        this.disableControls = true;
        this.$store
          .dispatch(SOURCE_FILTER_SAVE, settings)
          .then(result => {
            if (result) {
              console.log('FILTER_SAVE');
              this.$store.dispatch(SOURCE_FILTER_REQUESTAPPROVAL, settings).then(result => {
                if (result) {
                  console.log('FILTER_REQUESTAPPROVAL');
                  this.$store.dispatch(SOURCE_FILTER_APPROVE, settings).then(result => {
                    if (result) {
                      console.log('FILTER_APPROVE');
                      this.$store.dispatch(SOURCE_FILTER_PUBLISH, settings).then(result => {
                        if (result) {
                          this.$store.dispatch(SOURCE_GET, { "source": this.source_name });
                          this.disableControls = false;
                          console.log('FILTER_PUBLISH ' + result);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
      },
      saveCmmStartDate() {
        if (!this.validCmmStartDate()) {
          return;
        }
        var settings = this.sourceSettings;
        settings.can_send_expired_claims_to_cmm = this.isToggled;
        this.$bvModal.msgBoxConfirm('Are you sure you want to update the start date?', {
          title: 'CMM Start Date',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value === true) {
            this.saveSourceFilter(settings);
          }
        });
      },
      strToDate(date) {
        if (date) {
          var [yr, month, day] = date.split('-');
          return new Date(yr, month - 1, day);
        }
        return null;
      },
      dateToStr(date) {
        if (date) {
          var d = date.getDate();
          var m = date.getMonth() + 1;
          var y = date.getFullYear();
          return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        }
        return '';
      },
      validCmmStartDate() {
        var isValidDate = true;
        if (this.cmmStartDate === null || this.cmmStartDate.toString() === 'Invalid Date') {
          isValidDate = false;
        }
        this.invalidCmmStartDate = !isValidDate;
        return isValidDate;
      }
    },
    created() {
      if (this.source_name) {
        this.$store.dispatch(SOURCE_GET, { "source": this.source_name });
      }
    }
  };

</script>
<style lang="scss">
  .copay-epa-source-item {
    .filter-card {
      margin-bottom: 10px;
    }

    .filter-card .card-body {
      padding: 10px;
    }

    .filter-add {
      padding-left: 0;
    }

    .filter-add i {
      padding-top: 12px;
      padding-bottom: 10px;
    }

    .filter-edit.col-3 i {
      padding-left: 5px;
      padding-right: 5px;
    }

    .b-form-group {
      .form-value {
      padding: 7px;
      font-size: 14px;
      }
    }

    .source-status {
      font-weight: bold;
    }

    .text-danger {
      border-color: red;
    }

    span.text-danger {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/CopayEPASourceItem.vue